@if (loadingService.isLoading()) {
  <div class="loading-overlay">
    <mat-progress-spinner mode="determinate" [value]="25" diameter="48" class="clean-spin"/>
    <p>Chargement en cours...</p>
  </div>
}
